import { Space, Tag, Spin } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import TableWithSorter from '../../Common/TableWithSorter';

const UnitTable = (props) => {
  const {
    data,
    current,
    totalCount,
    onPaginationChange,
    offset,
    fetching,
  } = props;
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      sorter: (a, b) => a.code.localeCompare(b.code),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/unit/' + record.code}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Subunits',
      key: 'subunits',
      dataIndex: 'subunits',
      render: (subunits) => {
        if (subunits) {
          return (
            <>
              {subunits.map((subunit, index) => {
                let color = subunit.length > 5 ? 'geekblue' : 'green';
                return (
                  <Tag color={color} key={index}>
                    {subunit.code}
                  </Tag>
                );
              })}
            </>
          );
        }
      },
    },
  ];

  return (
    <div>
      {fetching ? <Spin /> : null}
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <TableWithSorter
            loading={fetching}
            tableLayout="auto"
            scroll={{ x: 1000 }}
            expandable={{ defaultExpandAllRows: true }}
            columns={columns}
            dataSource={data}
            pagination={{
              current: current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 && !fetching ? <div>No record found</div> : null}
    </div>
  );
};

export default UnitTable;
